const Contact = function (contact) {
	var instance = this;
	var form = null;

	/**
	 * Submit
	 * @return {object} jqXHR
	 */
	this.submit = function () {
		if (form) {
			return $.ajax({
				url: `${POMS_URL}/api/doctor/upload`,
				method: 'post',
				global: false,
				data: form,
				contentType: false,
				processData: false,
			});
		}
	};

	this.validate = function (fields) {
		let state = true;
		const errors = {};

		Object.entries(fields).forEach(([field, value]) => {
			if (!value) {
				state = false;
				errors[field] = true;
			}
		});

		return { state, errors };
	};

	/**
	 * Set
	 * @return {object} Contact
	 */
	this.set = function (contact) {
		if (contact) {
			form = new FormData();

			form.append('patient_name', contact.full_name);
			form.append('patient_dob', contact.birthday);
			form.append('doctor_clinic_name', contact.clinic);
			form.append('doctor_phone_number', contact.phone);
			form.append('doctor_state', contact.state);
			form.append('key', contact.key);
		}

		return instance;
	};
	(function construct(instance, contact) {
		if (contact) {
			instance.set(contact);
		}
	})(this, contact);
};

export default Contact;
